module.exports = __webpack_public_path__ + "static/img/pc-screen-001.1c5347c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc-screen-001.png
// module id = MtGd
// module chunks = 1